import './App.scss';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Login from './authentification/login';
import { AuthService } from './authentification/login/service';
import Layout from './shared/components/Layout';
import { routes } from './shared/data/routes';
import { handleError } from './shared/functions/handleError';
import authSlice from './store/slices/auth.slice';
import enumsSlice from './store/slices/enums.slice';
import { RootState } from './store/store';
import i18n from './utils/localization/i18n';

const NotFound = () => <h1>404 - Page Not Found</h1>;

function App() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const location = useLocation();
  const token = localStorage.getItem('token');
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const [authLoaded, setAuthLoaded] = useState(false);

  useEffect(() => {
    AuthService.enums()
      .then((response) => {
        dispatch(enumsSlice.actions.setEnums(response));
      })
      .catch(handleError);
  }, [dispatch]);

  useEffect(() => {
    if (token && !isAuthenticated) {
      AuthService.me(token)
        .then(async (response) => {
          await i18n.changeLanguage(response?.language);
          dispatch(
            authSlice.actions.setLoginState({
              isAuthenticated: true,
              userData: response,
            }),
          );
        })
        .catch(handleError)
        .finally(() => {
          setAuthLoaded(true);
        });
    } else {
      setAuthLoaded(true);
    }
  }, [token, dispatch, isAuthenticated, t]);

  if (!authLoaded) {
    return null;
  }

  if (!isAuthenticated && location.pathname !== '/') {
    return <Navigate to="/" replace />;
  }

  if (isAuthenticated && location.pathname === '/') {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return (
    <Routes>
      {!isAuthenticated && <Route path="/" element={<Login />} />}

      {isAuthenticated && (
        <>
          {routes?.map((route) => {
            return (
              <Route
                key={route?.route}
                path={route?.route}
                element={<Layout>{route?.component}</Layout>}
              />
            );
          })}
          <Route path="*" element={<NotFound />} />
        </>
      )}
    </Routes>
  );
}

export default App;
